module.exports = __webpack_public_path__ + "static/img/cont2303.2d2cb9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2303.jpg
// module id = qAEk
// module chunks = 0